export default __webpack_public_path__ + "bg.b5930e2.jpg";